"use client";

import moment from "moment-with-locales-es6";
import { useEffect, useState, type JSX } from "react";

interface IProps {
  date: moment.MomentInput;
  type: "format" | "fromNow";
  format?: string;
  prepend?: JSX.Element | string;
  append?: JSX.Element | string;
}

const MomentClientLocale: React.FC<IProps> = ({ date, type, format, prepend, append }) => {
  const [value, setValue] = useState("");

  useEffect(() => {
    if (type === "format") {
      setValue(moment(date).locale("en").format(format));
    } else if (type === "fromNow") {
      setValue(moment(date).locale("en").fromNow());
    }
  }, []);

  return (
    <>
      {prepend ?? <></>}
      {value}
      {append ?? <></>}
    </>
  );
};

export default MomentClientLocale;
